<template>
  <section class="main__register">
    <div class="main__register__frm">
          <p id="descSendBook1">
        لطفا فایل دیجیتال کتاب های خود (با فرمت pdf) را برای استفاده سایر علاقمندان از طریق فرم زیر برای ما ارسال فرمائید
      </p>
      <div class="register__box">
        <p id="titleForm">فرم ارسال کتاب</p>
        <div id="sendBookForm">
          <b-form-group label="نام و نام خانوادگی* :">
            <b-form-input
              v-model="name"
              placeholder="مانند سعید دهقان"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="موبایل* :">
            <b-form-input
              v-model="phone"
              :type="getType()"
              placeholder="09110001234"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="ایمیل:">
            <b-form-input
              v-model="email"
              placeholder="مانند info@gmail.com"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="توضیحات :">
            <b-form-input
              v-model="description"
              placeholder="توضیح کوتاهی در مورد کتاب شما"
            ></b-form-input>
          </b-form-group>
           <b-form-group style="display:none" label="توضیحات :">
            <b-form-textarea
              v-model="honey_pot"
              placeholder="توضیح کوتاهی در مورد کتاب شما"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group label="ارسال کتاب* :">
            <b-form-file
              accept=".pdf"
              v-model="file"
              :state="Boolean(file)"
              placeholder="فایل را انتخاب کنید"
              drop-placeholder="کتاب را اینجا بگذارید"
            ></b-form-file>
          </b-form-group>
          <span id="alertPdf"
            ><i class="fa fa-info"></i>ارسال کتاب با فرمت پی دی اف امکان پذیر
            است</span
          >
          <b-button :class="{'disabled':disabled==true}" id="sendBtn" @click="sendBook()" variant="primary"
            >{{sendButtonName}}</b-button
          >
        </div>
      </div>
    </div>

    <div class="main__register__img">
      <p id="descSendBook">
        لطفا فایل دیجیتال کتاب های خود (با فرمت pdf) را برای استفاده سایر علاقمندان از طریق این صفحه برای ما ارسال فرمائید
      </p>
      <img id="booksImage" src="../assets/images/Book/SVG/1.png" alt="" />
    </div>
  </section>
</template>
<script>
import {
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormTextarea,
  BButton
} from "bootstrap-vue";
export default {
  components: { BFormGroup, BFormInput, BFormFile, BFormTextarea, BButton },
  data() {
    return {
      name: "",
      phone: null,
      email: "",
      description: "",
      file: null,
      honey_pot:"",
      sendButtonName:"ارسال کتاب"
    };
  },
  methods: {
    sendBook() {
      if (this.name.length < 4) {
      return  this.$swal({
          icon: "warning",
          title: "خطا",
          showConfirmButton: true,
          text: "نام و نام خانوادگی باید  بیشتراز 4 حرف داشته باشد",
          button: "باشه"
        });
      }
      if(this.phone==null){
             return  this.$swal({
          icon: "warning",
          title: "خطا",
          showConfirmButton: true,
          text: "شماره تماسی وارد نشده است",

          button: "باشه"
        });
      }else if(this.phone.length!=11){
           return  this.$swal({
          icon: "warning",
          title: "خطا",
          showConfirmButton: true,
          text: "شماره تماس به درستی وارد نشده است",

          button: "باشه"
        });
      }
      if(this.file==null){
                     return  this.$swal({
          icon: "warning",
          title: "خطا",
          showConfirmButton: true,
          text: "فایل کتاب وارد نشده است",
          button: "باشه"
        });
      } 
      let formData=new FormData();
      formData.append("name",this.name)
      formData.append("mobile",this.phone)
      formData.append("description",this.description)
      formData.append("file",this.file)
      formData.append("email",this.email)
      formData.append("honey_pot",this.honey_pot)
      this.sendButtonName="درحالی بررسی"
      this.disabled=true;
      this.$axios.post("/front/request-publish-books",formData).then(res=>{
                       this.$swal({
          icon: "success",
          title: "تبریک",
          showConfirmButton: true,
          text: res.data.message,
          button: "باشه"
        });
              this.sendButtonName="ارسال"
      this.disabled=false;
      }).catch(error=>{
          if(error.response.errors && error.response.status == 422){

          }
      })
    },
    getType() {
      if (window.innerWidth < 768) {
        return "tel";
      } else {
        return "number";
      }
    }
  },
  metaInfo() {
    return {
      title: "ارسال کتاب",
      meta: [
        {
          name: "description",
          content:
            "ارسال کتاب برای کتابخانه میرداماد تا توسط این وبسایت به انتشار گذاشته شود"
        },
        {
          property: "og:title",
          content: "ارسال کتاب برای کتابخانه میرداماد"
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  }
};
</script>
<style scoped>
#booksImage {
  width: 320px;
}
.main__register {
  width: 90%;
  margin: 20px auto;
}
.main__register__frm .register__box {
  width: 90%;
}
#titleForm {
  font-size: 20px;
  font-weight: 600;
}
#sendBookForm {
  padding: 20px;
}
#alertPdf {
  padding: 10px 0;
  color: #ffa500e6;
  font-size: 18px;
  display: block;
}
#alertPdf i {
  margin-left: 10px;
}
#sendBtn {
  width: 60%;
  margin-right: 20%;
}
.disabled{
    opacity: 0.7;
    pointer-events: none;
    cursor: not-allowed;
}
#descSendBook{
  padding: 15px 30px;
  font-size:20px;
  font-weight: 500;
  font-family:"irancell"
}
  #descSendBook1{
  display: none;

  }
@media (max-width: 768px){
  .main__register{
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .main__register__frm{
    width: 95%;
  }
  #alertPdf{
    font-size: 16px;
  }
#descSendBook{
  display: none;
}
  #descSendBook1{
  padding: 15px ;
  font-size:17px;
display: block;
 font-weight: 500;
  font-family:"irancell"
  }
}

</style>
